<div>
	<br />
	<h5 fxLayoutAlign="center center" class="mt-0">{{ title }}</h5>
	<table *ngIf="hoursTotals && hoursTotals.length > 0" mat-table [dataSource]="hoursTotals" class="totals-table">
		<ng-container matColumnDef="credit">
			<th mat-header-cell class="header" *matHeaderCellDef>{{ firstColumnTitle }}</th>
			<td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
		</ng-container>

		<ng-container matColumnDef="hours">
			<th mat-header-cell class="header" *matHeaderCellDef>Hours</th>
			<td mat-cell *matCellDef="let element">{{ element.hours | hoursMinutes }}</td>
		</ng-container>

		<ng-container matColumnDef="factor">
			<th mat-header-cell class="header" *matHeaderCellDef>Factor</th>
			<td mat-cell *matCellDef="let element">{{ element.factor }}%</td>
		</ng-container>

		<ng-container matColumnDef="adjustedHours">
			<th mat-header-cell class="header" *matHeaderCellDef>Adjusted Hours</th>
			<td mat-cell *matCellDef="let element">{{ element.adjustedHours | hoursMinutes }}</td>
		</ng-container>

		<tr class="header-row" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr class="table-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<table *ngIf="dollarTotals && dollarTotals.length > 0" mat-table [dataSource]="dollarTotals" class="totals-table">
		<ng-container matColumnDef="credit">
			<th mat-header-cell class="header" *matHeaderCellDef>{{ firstColumnTitle }}</th>
			<td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
		</ng-container>

		<ng-container matColumnDef="hours">
			<th mat-header-cell class="header" *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element"></td>
		</ng-container>

		<ng-container matColumnDef="factor">
			<th mat-header-cell class="header" *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element"></td>
		</ng-container>

		<ng-container matColumnDef="adjustedHours">
			<th mat-header-cell class="header" *matHeaderCellDef>Total</th>
			<td mat-cell *matCellDef="let element">{{ element.adjustedHours | currency }}</td>
		</ng-container>

		<tr class="header-row" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr class="table-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<table
		*ngIf="secondaryTotals && secondaryTotals.length > 0"
		mat-table
		[dataSource]="secondaryTotals"
		class="totals-table"
	>
		<ng-container matColumnDef="credit">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element">{{ element.displayName }}</td>
		</ng-container>

		<ng-container matColumnDef="hours">
			<th mat-header-cell *matHeaderCellDef class="font-weight-bold">{{ secondaryTotalsHeader }}</th>
			<td mat-cell *matCellDef="let element">{{ element.hours | hoursMinutes }}</td>
		</ng-container>

		<ng-container matColumnDef="factor">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element">{{ element.factor }}%</td>
		</ng-container>

		<ng-container matColumnDef="adjustedHours">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element">{{ element.adjustedHours | hoursMinutes }}</td>
		</ng-container>

		<tr class="header-row" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr class="table-row" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<div *ngIf="totalOfHoursSummary" class="totals-table">
		<div class="row">
			<div class="column1 total-header padding-top-5">&nbsp;</div>
			<div class="column2 total-header padding-top-5">Total</div>
		</div>
		<div class="row">
			<div class="column1">Total</div>
			<div class="column2" *ngIf="!isTotalDollars">{{ totalOfHoursSummary.total | hoursMinutes }}</div>
			<div class="column2" *ngIf="isTotalDollars">{{ totalOfHoursSummary.total | currency }}</div>
		</div>
		<div *ngIf="totalOfHoursSummary.guaranteedHours" class="row">
			<div class="column1">Guaranteed Hours</div>
			<div class="column2">{{ totalOfHoursSummary.guaranteedHours | hoursMinutes }}</div>
		</div>
		<div *ngIf="totalOfHoursSummary.overGuaranteedHours" class="row">
			<div class="column1">Over Guaranteed Hours</div>
			<div class="column2">{{ totalOfHoursSummary.overGuaranteedHours | hoursMinutes }}</div>
		</div>
	</div>
</div>
